import axios from "axios";
import { CREDIT_CARDS } from "network/endpoints";
import ewbApi from "network/ewbApi";

export const fetchBanner = async () => ewbApi.get(CREDIT_CARDS.banner);

export const fetchBenefits = async () => ewbApi.get(CREDIT_CARDS.benefits);

export const fetchCardContents = async () =>
  axios.get(CREDIT_CARDS.cardContents);

export const fetchList = async () => ewbApi.get(CREDIT_CARDS.list);
